module.exports = __webpack_public_path__ + "media/country_flags/ke-596710ba.png";